import './simpleCalendar.scss';

import { Calendar } from '@eliberty/design-system-react';

import { getLocale } from '~helpers';
import { normalizeCalendarDate } from '~utils';

export interface SimpleCalendarProps {
  /** Minimum selectable date */
  minDate: Date;
  /** Maximum selectable date */
  maxDate?: Date;
  /** Currently selected date */
  selectedDate?: Date;
  /** Callback when a date is selected */
  onDateSelect: (date: Date | undefined) => void;
  /** Date intervals to exclude from selection */
  excludeDateIntervals?: { start: Date; end: Date }[];
  /** Range duration in days for multi-day selection */
  rangeDuration?: number;
  /** Custom render function for day cells */
  renderDayContents?: (dayOfMonth: number, date?: Date) => React.ReactNode;
  /** Callback when month changes */
  onMonthChange?: (date: Date) => void;
  /** Specific dates to include for selection */
  includeDates?: Date[];
  /** Date controlling the initially displayed month */
  openToDate?: Date;
}

/**
 * SimpleCalendar component provides a basic calendar.
 * It's the base component for more specialized calendar variants.
 */
const SimpleCalendar = ({
  minDate,
  maxDate,
  selectedDate,
  onDateSelect,
  excludeDateIntervals,
  includeDates,
  rangeDuration,
  renderDayContents,
  onMonthChange,
  openToDate,
}: SimpleCalendarProps) => {
  const locale = getLocale();

  const handleClick = (date: Date) => onDateSelect(normalizeCalendarDate(date));

  return (
    <div className='SimpleCalendar'>
      <Calendar
        minDate={minDate}
        maxDate={maxDate}
        onClick={handleClick}
        locale={locale}
        selectedDate={selectedDate}
        rangeDuration={rangeDuration}
        excludeDateIntervals={excludeDateIntervals}
        renderDayContents={renderDayContents}
        onMonthChange={onMonthChange}
        includeDates={includeDates}
        openToDate={openToDate}
      />
    </div>
  );
};

export default SimpleCalendar;
